import { MobileTopNavCTA } from "./types";

const GALAXY_STORE_URL = "https://galaxystore.samsung.com/detail/com.botb.winyourdreamcar";

const MobileTopNavCta = ({
  AndroidLinkDesktop,
  AndroidLinkMobile,
  IOSLinkDesktop,
  IOSLinkMobile,
  ShouldShowAndroidLink,
  ShouldShowIosLink,
}: MobileTopNavCTA) => {
  const iosHref = IOSLinkMobile || IOSLinkDesktop;
  const androidHref = AndroidLinkMobile || AndroidLinkDesktop;

  if (!ShouldShowIosLink && !ShouldShowAndroidLink) {
    return null;
  }

  return (
    <div className="grid grid-cols-2 gap-3 lg:gap-4 w-full min-w-0">
      {ShouldShowIosLink && iosHref && (
        <a
          href={iosHref}
          className="block w-full min-w-0"
          aria-label="Download on the App Store"
          rel="noopener noreferrer">
          <img
            src="/assets/images/menu/app-stores/app-store-badge.svg"
            alt="Download on the App Store"
            width={160}
            height={48}
            className="block w-full h-auto"
            loading="lazy"
          />
        </a>
      )}

      {ShouldShowAndroidLink && androidHref && (
        <a
          href={androidHref}
          className="block w-full min-w-0"
          aria-label="Get it on Google Play"
          rel="noopener noreferrer">
          <img
            src="/assets/images/menu/app-stores/google-play-badge.svg"
            alt="Get it on Google Play"
            width={160}
            height={48}
            className="block w-full h-auto"
            loading="lazy"
          />
        </a>
      )}

      {ShouldShowAndroidLink && (
        <a
          href={GALAXY_STORE_URL}
          className="block w-full min-w-0"
          aria-label="Available on Galaxy Store"
          rel="noopener noreferrer"
          target="_blank">
          <img
            src="/assets/images/menu/app-stores/galaxy-store-badge.svg"
            alt="Available on Galaxy Store"
            width={160}
            height={48}
            className="block w-full h-auto"
            loading="lazy"
          />
        </a>
      )}
    </div>
  );
};

export default MobileTopNavCta;
